import axios from "axios";
import type {
  AxiosError,
  AxiosInstance,
  AxiosRequestConfig,
  AxiosResponse,
} from "axios";

export interface RequestHooks {
  requestUse<T>(config: AxiosRequestConfig<T>): AxiosRequestConfig<T>;
  requestError<T, D>(error: AxiosError<T, D>): AxiosError<T, D>;
  responseUse<T, D>(config: AxiosResponse<T, D>): AxiosResponse<T, D>;
  responseError<T, D>(error: AxiosError<T, D>): AxiosError<T, D>;
}

const requestHooks: RequestHooks = {
  requestUse<T>(config: AxiosRequestConfig<T>): AxiosRequestConfig<T> {
    return config;
  },
  requestError<T, D>(error: AxiosError<T, D>): AxiosError<T, D> {
    return error;
  },
  responseUse<T, D>(config: AxiosResponse<T, D>): AxiosResponse<T, D> {
    return config;
  },
  responseError<T, D>(error: AxiosError<T, D>): AxiosError<T, D> {
    return error;
  },
};

// create an axios instance
const service: AxiosInstance = axios.create({
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 120000, // request timeout
});

// request interceptor
service.interceptors.request.use(
  (config: AxiosRequestConfig<any>): AxiosRequestConfig<any> => {
    config = requestHooks.requestUse(config);
    return config;
  },
  (error: AxiosError<any, any>) => {
    // do something with request error
    error = requestHooks.requestError(error);
    console.log(error); // for debug

    return Promise.reject(error);
  }
);

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
   */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  (response: AxiosResponse<any, any>) => {
    response = requestHooks.responseUse(response);
    return response;
  },
  (error: AxiosError<any, any>) => {
    error = requestHooks.responseError(error);
    console.log(error); // for debug
    return Promise.reject(error);
  }
);
export { requestHooks };
export default service;
